<template>
    <div>
        <h5 class="grey-color fw-600">Подтверждение требований к поставщикам</h5>
        <template v-if="purchaseItem.supplier_reqs_a">
            <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Поставщик подтвердил, что соответствует требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ" :value="offer.reply_supplier_reqs_a" value-class="text-right" />
            <text-row compact :label-cols-lg="5" :label-cols-sm="5" label="Поставщик подтвердил соответствие следующим требованиям" v-model="purchaseItem.supplier_requirements.supplier_reqs_a_text" />
            <supplier-requirement-supplier-reqs-a-view-table :documents="offer.supplier_required_documents" />
        </template>
        <text-row-boolean-text v-if="purchaseItem.supplier_reqs_b" compact :label-cols-lg="11" :label-cols-sm="11" label="Поставщик подтвердил, что соответствует требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ" :value="offer.reply_supplier_reqs_b" value-class="text-right" />
        <text-row-boolean-text v-if="purchaseItem.supplier_reqs_c" compact :label-cols-lg="11" :label-cols-sm="11" label="Поставщик подтвердил, что соответствует требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ" :value="offer.reply_supplier_reqs_b" value-class="text-right" />
        <text-row-boolean-text v-if="purchaseItem.supplier_reqs_sonko" compact :label-cols-lg="11" :label-cols-sm="11" label="Поставщик подтвердил, что является СОНКО" hint="Социально ориентированная некоммерческая организация" :value="offer.reply_supplier_reqs_sonko" value-class="text-right" />
        <template v-if="purchaseItem.supplier_requirements.additional.state[0]">
            <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Поставщик подтвердил соответствие дополнительным требованиям" :value="offer.supplier_requirements.additional.state[1]" value-class="text-right" />
            <additional-supplier-requirements-view-table :documents="offer.supplier_requirements.additional.requirements" />
        </template>
    </div>
</template>

<script>
import SupplierRequirementSupplierReqsAViewTable
    from '@/components/products/fl44/partials/supplier-requirement-supplier-reqs-a-view-table.vue';
import AdditionalSupplierRequirementsViewTable
    from '@/components/products/fl44/partials/additional-supplier-requirements-view-table.vue';

export default {
    name: 'offer-supplier-requirements-view',
    components: { AdditionalSupplierRequirementsViewTable, SupplierRequirementSupplierReqsAViewTable },
    props: {
        purchaseItem: {
            type: Object,
            required: true
        },
        offer: {
            type: Object,
            required: true
        }
    }
};
</script>
